export default __webpack_public_path__ + "static/media/working-new-4.b3f50d30.png";